import { memo } from "react";
import { ComputedDatum, ResponsivePie } from "@nivo/pie";
import { getSuffixedNumber } from "@zenith/utils";
import { EmptyChartCardComponent } from "@zenith/features/Analytics";

interface PieChartComponentProps {
  data: PieDataProps[];
  isQuantity?: boolean;
  filter?: string;
}

interface PieDataProps {
  id: string;
  label: string;
  value: number;
  formattedValue?: string;
  color: string;
  index: number;
  indexValue: string | number;
}

const InventoryPieChartComponent = memo(function InventoryPieChartComponent(
  props: PieChartComponentProps
) {
  const { data, isQuantity, filter } = props;

  function formatValue(value: number): string {
    return isQuantity
      ? getSuffixedNumber(value, 0, 0)
      : getSuffixedNumber(value, 2, 2);
  }

  function handleArcLabelValue(datum: ComputedDatum<PieDataProps>): string {
    const { formattedValue } = datum;
    return formattedValue ?? formatValue(datum.value);
  }

  return (
    <div className="flex rounded-1.5lg border border-zinc-300 bg-white p-2.5 md:p-4 lg:p-8">
      {!data.length ? (
        <EmptyChartCardComponent />
      ) : (
        <div
          className=" h-full w-full"
          style={{ height: "24rem", maxWidth: 500 }}
        >
          {filter && (
            <div className="  ml-auto flex w-fit items-center gap-2 rounded-lg bg-neutral-transparent-200 py-1 px-3 text-neutral-600">
              <span className="inline-block h-2 w-2 rounded-full bg-neutral-600"></span>
              <span className="text-xs font-medium">{filter}</span>
            </div>
          )}

          <ResponsivePie
            data={data.map((d) => ({
              ...d,
              formattedValue: formatValue(d.value),
            }))}
            margin={{ right: 140, left: 10 }}
            innerRadius={0.5}
            cornerRadius={0}
            colors={{ datum: "data.color" }}
            theme={{}}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
              from: "color",
              modifiers: [["darker", 0.1]],
            }}
            valueFormat={(value) => formatValue(Number(value))}
            enableArcLabels={true}
            arcLabelsTextColor={"white"}
            arcLabelsSkipAngle={15}
            arcLabel={(a) => handleArcLabelValue(a)}
            enableArcLinkLabels={false}
            arcLinkLabelsSkipAngle={2}
            arcLinkLabelsColor={{
              from: "color",
            }}
            arcLinkLabelsThickness={1}
            arcLinkLabel={(d) =>
              d.value > 0 ? `${d.id}: ${formatValue(d.value)}` : ""
            }
            legends={[
              {
                anchor: "right",
                direction: "column",
                justify: false,
                translateX: 150,
                itemsSpacing: 20,
                itemWidth: 120,
                itemHeight: 18,
                itemTextColor: "#1A1C1F",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 10,
                symbolShape: "square",
              },
            ]}
          />
        </div>
      )}
    </div>
  );
});

export default InventoryPieChartComponent;
